import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { DBService } from '../../service';
import { AuthLog,RDSAuditData } from '../../model/analysis-details.model';

import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import _moment, { default as _rollupMoment } from 'moment';

import { FormControl } from '@angular/forms';
import { AuthNewService } from '../../service/auth-new.service';
import { Subscription } from 'rxjs';
import { StorageService } from '../../service/storage.service';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  providers: [{
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
  },
  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class UserComponent implements OnInit, OnDestroy {
  date = new FormControl(moment());
  pageTitle = 'Audit';
  signedInUser: any;
  loading = false;
  username?: string;
  email?: string;
  reportKey = '';
  fileLink: any;
  logdata: Array<AuthLog> = [];
  users: any[] = [];
  auditAnalysisKeys: RDSAuditData[] = [];
  loginSelected = '';
  monthSelected = '';
  temp_loginData: any;
  temp_analysisData: any;
  clicked = false;
  months = ['January', 'Feburary', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  pageLoaded = false;
  title = 'Loading';
  @ViewChild('datePicker') public dp: any;
  role?: string | null ;
  public startDate ='none';
  public endDate='none';
  userAttributes?:string | null;
  illegalUser?: boolean;
  showTable = false;
  private rdsAuditDataSubscription?: Subscription;
  private currentLoginUser?: Subscription;
  maxDate = new Date();
  auditFlag=false;
  dateRangeStart?:moment.Moment | null;
  dateRangeEnd?:moment.Moment | null;

  constructor(
    private authService: AuthNewService,
    private dbService: DBService,
    private _sharedService:SharedService,
    private storageService:StorageService) {
       this._sharedService.emitChange(this.pageTitle);
  }

  async ngOnInit() {
    this.role=this.storageService.get('access');
    this.userAttributes = this.storageService.get('access');
    this.authService.getCurrentUser();
      if (this.userAttributes === 'PI') {
        this.illegalUser = true;
      }

     if (this.userAttributes == 'GA'|| this.userAttributes == 'SU'|| this.userAttributes == 'QA'){

      this.illegalUser = false;
      this.showTable = true;
      this.auditFlag=true;
        this.dbService.getAuditAnalysis(this.role!, this.startDate ,this. endDate ,this.auditFlag);
        this.rdsAuditDataSubscription = this.dbService.rdsAuditData.subscribe(
          (data: RDSAuditData[]) => {
            this.auditAnalysisKeys = data;

          },(error) => {
            console.error('Error fetching audit analysis:', error);
          }
        );
    }

  }

  clearSelectedDates(){
    this.auditAnalysisKeys = [];
   this.dateRangeEnd=null;
   this.dateRangeStart=null;
    this.startDate = 'none';
    this.endDate = 'none';
    this.dbService.getAuditAnalysis(this.role!, this.startDate, this.endDate,this.auditFlag);

  }

  passSelectedDates() {
    this.auditAnalysisKeys = [];
  this.dbService.getAuditAnalysis(this.role!, this.startDate, this.endDate,this.auditFlag);

  }

  selectedDates() {
     this.startDate = this.dateRangeStart?.format('MM/DD/YYYY')?? 'none';
    this.endDate = this.dateRangeEnd?.format('MM/DD/YYYY')?? 'none';
    this.passSelectedDates();
  }



  ngOnDestroy() {
    // Unsubscribe from the observable to avoid memory leaks
    if (this.rdsAuditDataSubscription) {
      this.rdsAuditDataSubscription.unsubscribe();
    }
    if (this.currentLoginUser) {
      this.currentLoginUser.unsubscribe();
    }
  }
}


